const validate = (values) => {
    const errors = {};
  
    if (!values.targetName) {
      errors.targetName = 'Please enter target name';
    }
    if (!values.domainId || !Number.isInteger(values.domainId)) {
      errors.domainId = 'Please select domain';
    }
    if (!values.programId || !Number.isInteger(values.programId)) {
      errors.programId = 'Please select program';
    }
    // if (!values.goalName) {
    //   errors.goalName = 'Please enter goal name';
    // }
    // if (!values.sd) {
    //   errors.sd = 'Please enter sd name';
    // }
    // if (!values.desiredDailyTrialsId || !Number.isInteger(values.desiredDailyTrialsId)) {
    //   errors.desiredDailyTrialsId = 'Please select daily trails';
    // }
    // if (!values.autoOpenOrderId || !Number.isInteger(values.autoOpenOrderId)) {
    //   errors.autoOpenOrderId = 'Please select auto-open order';
    // }
    if (!values.targetTypeId || !Number.isInteger(values.targetTypeId)) {
      errors.targetTypeId = 'Please select target type';
    }

    if (values.responseCriteria > 100) {
      errors.responseCriteria = 'Response criteria can not be greater than 100.';
    }
    
    // if (!values.targetInstructions) {
    //   errors.targetInstructions = 'Please enter target instructions';
    // }
    // if (!values.responsePercentageId || !Number.isInteger(values.responsePercentageId)) {
    //   errors.responsePercentageId = 'Please select reponse percentage';
    // }
    // if (!values.consecutiveDaysId || !Number.isInteger(values.consecutiveDaysId)) {
    //   errors.consecutiveDaysId = 'Please select consecutive days';
    // }
    // if (!values.firstTrialMustBeIndependentId || !Number.isInteger(values.firstTrialMustBeIndependentId)) {
    //   errors.firstTrialMustBeIndependentId = 'Please select first trial must be independent';
    // }

    if (values.taskAnalysisModel && values.taskAnalysisModel.length) {
      const taskAnalysisModelArrayErrors = [];
      //const modifiersArray = values.taskAnalysisModel.map((obj) => obj.id);
      values.taskAnalysisModel.forEach((taskAnalysisObj, Index) => {
        const taskAnalysisErrors = {};
        //if (taskAnalysisObj && taskAnalysisObj.id) {
          // let isModifierIndex = (modifiersArray || []).findIndex((obj) => (obj || '').toLowerCase() === (taskAnalysisObj.id || '').toLowerCase());
          // if (isModifierIndex > -1 && isModifierIndex !== Index) {
          //   taskAnalysisErrors.id = 'Please select enter step.';
          //   taskAnalysisModelArrayErrors[Index] = taskAnalysisErrors;
          // }
          if (!taskAnalysisObj.taskName) {
            taskAnalysisErrors.taskName = 'Please enter task name.';
            taskAnalysisModelArrayErrors[Index] = taskAnalysisErrors;
          }
          if (!taskAnalysisObj.displayOrder) {
            taskAnalysisErrors.displayOrder = 'Please enter display order.';
            taskAnalysisModelArrayErrors[Index] = taskAnalysisErrors;
          }
        // }
        // if (taskAnalysisObj && taskAnalysisObj.rate && !taskAnalysisObj.id) {
        //   taskAnalysisErrors.id = 'Please select modifier.';
        //   taskAnalysisModelArrayErrors[Index] = taskAnalysisErrors;
        // }
        return taskAnalysisErrors;
      });
      if (taskAnalysisModelArrayErrors.length) {
        errors.taskAnalysisModel = taskAnalysisModelArrayErrors;
      }
    }

    return errors;
  };
  export default validate;
  


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/validate.js